

const TimeLapse = ({fill}: {fill?: string}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3263 5.16666C10.5463 4.38666 9.52634 3.99333 8.49967 3.99333V7.99333L5.67301 10.82C7.23301 12.38 9.76634 12.38 11.333 10.82C12.893 9.25999 12.893 6.72666 11.3263 5.16666ZM8.49967 1.32666C4.81967 1.32666 1.83301 4.31333 1.83301 7.99333C1.83301 11.6733 4.81967 14.66 8.49967 14.66C12.1797 14.66 15.1663 11.6733 15.1663 7.99333C15.1663 4.31333 12.1797 1.32666 8.49967 1.32666ZM8.49967 13.3267C5.55301 13.3267 3.16634 10.94 3.16634 7.99333C3.16634 5.04666 5.55301 2.65999 8.49967 2.65999C11.4463 2.65999 13.833 5.04666 13.833 7.99333C13.833 10.94 11.4463 13.3267 8.49967 13.3267Z"
        fill={fill || "#2FC2DF"}
      />
    </svg>
  );
};

export default TimeLapse